import * as yup from "yup";
import { FormikProps } from "formik";
import React, { useEffect, useState } from "react";
import { formatDate } from "../../../../helpers/date.tx";
import { Grid, TextField } from "@material-ui/core";
import { Dropdown } from "../../../../app/components/Dropdown";

import classes from "./index.module.scss";

export const ExportSettingsValidationSchema = yup.object({
  exportDefaultUnits: yup.string(),
  exportEnumerationDivider: yup.string()
    .test('dividersEnumeration', 'Cannot use the same dividers', (_, schema) => {
      const { exportEnumerationDivider, exportFieldDivider, exportDecimalDivider } = schema.parent;

      return exportEnumerationDivider !== exportFieldDivider && exportEnumerationDivider !== exportDecimalDivider

    })
    .required('Required'),
  exportFieldDivider: yup.string()
    .test('dividersField', 'Cannot use the same dividers', (_, schema) => {
      const { exportEnumerationDivider, exportFieldDivider, exportDecimalDivider } = schema.parent;

      return exportEnumerationDivider !== exportFieldDivider && exportFieldDivider !== exportDecimalDivider

    })
    .required('Required'),
  exportDecimalDivider: yup.string()
    .test('dividersDecimal', 'Cannot use the same dividers', (_, schema) => {
      const { exportEnumerationDivider, exportFieldDivider, exportDecimalDivider } = schema.parent;

      return exportEnumerationDivider !== exportDecimalDivider && exportFieldDivider !== exportDecimalDivider

    })
    .required('Required'),
  exportDecimalPlaceDigits: yup.number()
    .typeError('Should be a number')
    .required('Required'),
  exportFormatDate: yup.string()
    .test('dividerDate', 'Cannot use field divider in date format', (_, schema) => {
      const { exportFormatDate, exportFieldDivider } = schema.parent;

      return !~exportFormatDate.indexOf(exportFieldDivider);
    })
    .required('Required'),
});

interface FormikInterface {
  exportDefaultUnits: string,
  exportEnumerationDivider: string,
  exportFieldDivider: string,
  exportDecimalDivider: string,
  exportDecimalPlaceDigits: number,
  exportFormatDate: string,
}

const FrequencyItems = [
  {
    id: 'Hz',
    name: 'Hz',
  },
  {
    id: 'kHz',
    name: 'kHz',
  },
  {
    id: 'MHz',
    name: 'MHz',
  },
  {
    id: 'GHz',
    name: 'GHz',
  },
];

const fieldDividerItems = [
  {
    id: ',',
    name: '"," (coma) as field separator',
  },
  {
    id: ';',
    name: '";" (semicolon) as field separator and',
  }
];

const dateToOutput = new Date();

const ExportSettingsForm = (props: { settingsFormik: FormikProps<FormikInterface> }) => {
  const [ dateOutput, setDate ] = useState('');
  const { settingsFormik } = props;

  const updateOutputDate = (format) => {
    const date = formatDate(dateToOutput, format)
    setDate(date);
  }

  useEffect(() => {
    updateOutputDate(settingsFormik.values.exportFormatDate);
  }, []);

  const onDateChange = (e) => {
    updateOutputDate(e.target.value);
    settingsFormik.handleChange(e);
  }

  return (
    <Grid container className={classes.form}>
      <Grid item xs={3} className={classes.formItem}>
        <Dropdown
          selectedValue={settingsFormik.values.exportFieldDivider}
          values={fieldDividerItems}
          label='Default field separator'
          name='exportFieldDivider'
          fullWidth
          valueChange={settingsFormik.handleChange}
          error={settingsFormik.errors.exportFieldDivider}
        />
      </Grid>
      <Grid item xs={3} className={classes.formItem}>
        <TextField
          label='Default list items separator'
          variant='outlined'
          name='exportEnumerationDivider'
          fullWidth
          value={settingsFormik.values.exportEnumerationDivider}
          onChange={settingsFormik.handleChange}
          helperText={settingsFormik.errors.exportEnumerationDivider}
          error={Boolean(settingsFormik.errors.exportEnumerationDivider)}
        />
      </Grid>
      <Grid item xs={3} className={classes.formItem}>
        <TextField
          label='Default decimal place separator'
          variant='outlined'
          name='exportDecimalDivider'
          fullWidth
          value={settingsFormik.values.exportDecimalDivider}
          onChange={settingsFormik.handleChange}
          helperText={settingsFormik.errors.exportDecimalDivider}
          error={Boolean(settingsFormik.errors.exportDecimalDivider)}
        />
      </Grid>
      <Grid item xs={3} className={classes.formItem}>
        <TextField
          label='Default decimal place count'
          variant='outlined'
          name='exportDecimalPlaceDigits'
          fullWidth
          value={settingsFormik.values.exportDecimalPlaceDigits}
          onChange={settingsFormik.handleChange}
          helperText={settingsFormik.errors.exportDecimalPlaceDigits}
          error={Boolean(settingsFormik.errors.exportDecimalPlaceDigits)}
        />
      </Grid>


      <Grid item xs={3} className={classes.formItem}>
        <Dropdown
          selectedValue={settingsFormik.values.exportDefaultUnits}
          values={FrequencyItems}
          label='Default frequency units'
          name='exportDefaultUnits'
          fullWidth
          valueChange={settingsFormik.handleChange}
          error={settingsFormik.errors.exportDefaultUnits}
        />
      </Grid>
      <Grid item xs={3} className={classes.formItem}>
        <TextField
          label='Default data format'
          variant='outlined'
          name='exportFormatDate'
          fullWidth
          value={settingsFormik.values.exportFormatDate}
          onChange={onDateChange}
          helperText={settingsFormik.errors.exportFormatDate}
          error={Boolean(settingsFormik.errors.exportFormatDate)}
        />
      </Grid>
      <Grid item xs={3} className={classes.formItem}>
        <TextField
          label='Date format output preview'
          variant='outlined'
          name='dateOutput'
          disabled
          fullWidth
          value={dateOutput}
          onChange={() => {}}
        />
      </Grid>
    </Grid>
  )
}

export default ExportSettingsForm;